import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Entrepreneurship() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Human Practices
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Entrepreneurship
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Entrepreneurship
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Overview
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-1-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Executive summary
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Product
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-2-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Feasibility
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-2-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Viability
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-2-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Scalability
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-2-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Conclusion
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Development
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-3-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        SWOT Analysis
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-3-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Business Model Canvas
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Milestones
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-4-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Product Development & Research Milestones
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-4-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Market Analysis & Public Outreach
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-4-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Intellectual Property & Regulatory Strategy
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-4-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Commercialization & Go-To-Market Strategy
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-4-5")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Financial Plan & Funding Milestones
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-4-6")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Risk Management
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-5")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Long term impact
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-5-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Potential positive impact
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-5-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Potential negative impact
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-6")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Surveys
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-6-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Guanine Crystals & Cosmetics Industry
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-6-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                         Product Scalability & Vegan Guanine Crystal
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Entrepreneurship-7")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    References
                                </div>
                            </li>

                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Entrepreneurship-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Overview
                        </div>
                        <div id="Entrepreneurship-1-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Executive summary
                            </div>
                            <div className="mt-5">
                                BioGlimmer is pioneering a sustainable, vegan alternative for guanine crystal
                                production, which is a key ingredient in the cosmetics industry traditionally
                                sourced from fish scales (1). By leveraging genetically modified bacteria such as
                                E. coli, BioGlimmer seeks to produce guanine crystals through fermentation,
                                aligning with the growing demand for cruelty-free, eco-conscious beauty products.
                                This innovative approach not only addresses significant environmental concerns
                                but also taps into a market that increasingly values ethical and sustainable
                                practices. The technology behind BioGlimmer is scientifically sound and has the
                                potential to be both cost-effective and scalable. However, regulatory compliance,
                                technical complexities related to genetic modification, and educating the market
                                on the benefits of biosynthetic guanine are not easy to overcome. BioGlimmer’s
                                business model is centred on direct sales and licensing opportunities, with strong
                                partnerships in research, manufacturing, and advocacy playing a critical role in
                                advancing the company’s mission. As it moves through key phases such as product
                                development, public outreach, intellectual property protection, and regulatory
                                approvals, BioGlimmer aims to position itself as a leader in the sustainable
                                cosmetics space. The company has a clear first-mover advantage, but success will
                                depend on overcoming regulatory hurdles and ensuring market readiness through
                                strategic collaborations. With its scalable production process and commitment to
                                ethical sourcing, BioGlimmer is poised to reshape the cosmetics industry, driving
                                long-term changes in how beauty products are developed and marketed.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Entrepreneurship-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Product
                        </div>
                        <div id="Entrepreneurship-2-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Feasibility
                            </div>
                            <div className="mt-5">
                                The feasibility of BioGlimmer rests on its ability to address the challenges related
                                to the current production methods for guanine crystals in the cosmetics industry.
                                Traditionally, guanine crystals are sourced from fish scales or mining, both of
                                which are environmentally detrimental and non-vegan. This presents a strong
                                opportunity for BioGlimmer, which proposes a novel, more sustainable approach:
                                genetically modifying bacteria to produce guanine crystals through fermentation.
                            </div>
                            <div className="mt-5">
                                Research has shown that A. Caviae can endogenously synthesize guanine crystals,
                                and the genetic modifications proposed—such as overexpressing key genes and
                                knocking out regulatory elements—are supported by prior studies. This positions
                                BioGlimmer's approach as both scientifically viable and feasible in a lab
                                environment. While there are some technical challenges still to overcome, the
                                project’s partnerships with research institutions provide a solid foundation for
                                solving these challenges.
                            </div>
                            <div className="mt-5">
                                In terms of industry need, the growing consumer demand for vegan and ethically
                                sourced cosmetics makes this project highly relevant. With the backing of cosmetics
                                manufacturers and NGOs, BioGlimmer's solution could meet a market ready for
                                transformation. However, regulatory compliance around the use of genetically
                                modified organisms (GMOs) in beauty products will require rigorous navigation,
                                which adds a layer of complexity to the feasibility.
                            </div>
                        </div>
                        <div id="Entrepreneurship-2-2" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Viability
                            </div>
                            <div className="mt-5">
                                The average sales for the biggest 100 corporations, in 2003, when solely including
                                their cosmetics sales came to $2.0 billion (2). In 2021, the size of the worldwide
                                guanine market was 263.45 million USD. It is expected to grow at a strong rate of
                                10.3% reaching USD 474.52 million by 2027. A significant part of the market share
                                can be attributed to the crystalised form which seems to be the dominant one compared
                                to the powdered one. The Asian and Pacific region is the most important region to
                                target after the Swedish market as many guanine producing companies are based there
                                and they might be interested in expanding their product portfolio in a sustainable
                                way (3).
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/add/add-2.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <div className="mt-5">
                                LIST OF TOP GUANINE COMPANIES
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Wuxi Further Pharmaceutical Co. Ltd (China)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Haihang Industry Co., Ltd. (China)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Alsachim (France)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Zhejiang Oma Pharmaceutical Co., Ltd (China)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Wuhan Fude Chemical Co., Ltd (China)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Shaanxi Top Pharm Chemical Co., Ltd (China)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Jiangsu Baju Pharmaceutical Co., Ltd (China)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"></span>
                                Biosynth Carbosynth (U.K.)
                            </div>
                            <div className="mt-5">
                                Source:
                            </div>
                            <div>
                                https://www.businessresearchinsights.com/market-reports/guanine-market-108358
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s viability is enhanced by its potential to offer cost-effective and
                                scalable production of guanine crystals. Traditional methods of guanine extraction
                                are labour-intensive, environmentally unsustainable, and exclude a significant
                                portion of the vegan and eco-conscious market. By producing guanine crystals via
                                genetically modified bacteria, BioGlimmer can reduce the costs of sourcing this
                                critical ingredient while also eliminating the ethical concerns tied to non-vegan
                                practices.
                            </div>
                            <div className="mt-5">
                                The ability to licence our proprietary strains to cosmetics manufacturers represents
                                an additional revenue stream, ensuring that BioGlimmer’s model is financially
                                sustainable. Furthermore, BioGlimmer can market its crystals to premium cosmetics
                                brands, who can use the "sustainably sourced" claim to cater to a growing consumer
                                base that values ethical products.
                            </div>
                            <div className="mt-5">
                                However, time-to-market could be a challenge due to the need for comprehensive
                                testing and validation of the bacterial fermentation process at scale. Also,
                                educating the market about the benefits of biosynthetic guanine crystals over
                                traditional methods will be essential for gaining traction, as cosmetic companies
                                may initially be cautious of adopting biotech-based ingredients.
                            </div>
                        </div>
                        <div id="Entrepreneurship-2-3" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Scalability
                            </div>
                            <div className="mt-5">
                                BioGlimmer's potential for scalability lies in its biomanufacturing process. The
                                use of E. coli as a production organism is a well-established practice in the
                                biotech industry, meaning that the infrastructure for large-scale production
                                already exists. Once the bacterial strains are optimized for high-yield guanine
                                production, the process can be scaled up in bioreactors, significantly increasing
                                the volume of guanine crystals produced compared to traditional methods.
                            </div>
                            <div className="mt-5">
                                The global demand for ethical and vegan products is on the rise, driven by shifts
                                in consumer preferences toward more sustainable solutions. This trend represents
                                a significant opportunity for BioGlimmer to capture a share of the glimmer
                                cosmetics industry. The first-mover advantage of introducing a biosynthetic
                                alternative gives BioGlimmer a competitive edge in setting the standard for
                                sustainable sourcing in the industry.
                            </div>
                            <div className="mt-5">
                                Scalability will also benefit from collaborations with cosmetics manufacturers
                                and strategic partnerships with NGOs and ethical beauty organizations, who can
                                help promote BioGlimmer's message of sustainability. However, BioGlimmer will
                                need to navigate regulatory hurdles to ensure that its products can be approved
                                for widespread use in cosmetics. Working closely with regulatory bodies and
                                engaging in stakeholder education will be critical for scaling successfully.
                            </div>
                        </div>
                        <div id="Entrepreneurship-2-4" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Conclusion
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block"></span>
                                <span className="font-bold"> Feasibility</span>: BioGlimmer’s technology is scientifically sound and addresses a
                                real-world problem in the cosmetics industry. Challenges such as regulatory
                                compliance and technological complexity are significant but surmountable with
                                the right research and partnerships.
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block"></span>
                                <span className="font-bold"> Viability</span>: The project offers a viable business model, tapping into the growing
                                demand for vegan and sustainable products. Direct sales and licensing opportunities
                                ensure multiple revenue streams, though the time-to-market could be extended due to
                                necessary product validation.
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block"></span>
                                <span className="font-bold"> Scalability</span>: BioGlimmer’s use of well-established microbial production methods
                                allows for scalability. The increasing demand for ethical beauty products provides
                                a fertile market for growth, though market education and regulatory navigation are
                                key to ensuring smooth expansion.
                            </div>
                            <div className="mt-5">
                                BioGlimmer stands poised to be a transformative project that not only aligns with
                                global trends toward sustainability but also offers a scalable and financially
                                viable solution for the cosmetics industry.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Entrepreneurship-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Development
                        </div>
                        <div id="Entrepreneurship-3-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                SWOT Analysis
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/entrepreneurship/entrepreneurship-1.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <div className="mt-5">
                                BioGlimmer offers a novel and sustainable approach to guanine crystal production,
                                transforming how cosmetics manufacturers source this essential ingredient. By
                                utilizing genetically modified bacteria, BioGlimmer produces vegan, cruelty-free
                                guanine crystals, addressing the growing demand for ethical and environmentally
                                responsible alternatives in the beauty industry. This solution not only aligns
                                with the values of sustainability but also caters to vegan consumers, making it
                                an attractive proposition for brands aiming to meet these evolving market preferences.
                            </div>
                            <div className="mt-5">
                                One of the key strengths of BioGlimmer lies in its scalability. The use of E. coli,
                                a well-characterized and widely used bacterial strain, allows for efficient upscaling
                                in industrial use (4). Though scalability still needs to be verified in practice its
                                promise ensures that BioGlimmer has a marketable future and can meet both small-
                                and large-scale production needs, providing flexibility to cosmetics manufacturers
                                and setting the stage for market expansion.
                            </div>
                            <div className="mt-5">
                                The project also benefits from the growing trend toward ethical consumerism. As
                                consumers become more conscious of the environmental and ethical impact of their
                                purchases, the demand for products like BioGlimmer’s sustainable guanine crystals
                                will likely increase. This presents BioGlimmer with a significant first-mover
                                advantage, allowing it to lead the market in providing a viable alternative to
                                traditional guanine sourcing methods. Furthermore, collaborations with cosmetics
                                manufacturers offer BioGlimmer an opportunity to form valuable partnerships, which
                                can facilitate early market entry and product adoption.
                            </div>
                            <div className="mt-5">
                                Nevertheless, BioGlimmer faces several challenges. One key weakness is the
                                technological complexity of its genetic modification processes. Successfully
                                engineering bacterial strains to synthesize guanine crystals while maintaining
                                cell viability requires deep research know-how and may extend the time to market.
                                Additionally, BioGlimmer will need to invest in educating the market. Although
                                sustainability and veganism are growing trends, cosmetics manufacturers may require
                                further understanding of the benefits and advantages of switching to this innovative
                                solution.
                            </div>
                            <div className="mt-5">
                                Externally, BioGlimmer must navigate potential regulatory hurdles. As with any
                                product derived from genetically modified organisms (GMOs), approval processes
                                may vary across regions and could delay market access. The company will need to
                                stay attuned to regulatory changes and work proactively with governmental bodies
                                to ensure compliance. Another external threat lies in the competitive landscape.
                                As the cosmetics industry increasingly embraces sustainability, competitors may
                                also seek to develop alternative solutions for guanine production, necessitating
                                continuous innovation and research investment to stay ahead. Securing adequate
                                funding will be critical to overcoming these hurdles and maintaining BioGlimmer’s
                                competitive edge.
                            </div>
                            <div className="mt-5">
                                To mitigate these risks and capitalize on the opportunities, BioGlimmer must
                                prioritize strategic collaborations with both cosmetics manufacturers and regulatory
                                bodies. By fostering a strong network of partners and stakeholders, BioGlimmer can
                                enhance its market credibility and streamline its path to commercialization.
                                Furthermore, maintaining a commitment to research and development will be crucial
                                for adapting to technological advancements and evolving industry standards.
                            </div>
                            <div className="mt-5">
                                Ultimately, BioGlimmer’s innovative approach to guanine production holds the
                                potential to revolutionize the cosmetics industry, aligning with both environmental
                                sustainability and ethical consumerism. By leveraging its strengths, addressing
                                its weaknesses, and navigating external threats, BioGlimmer is well-positioned to
                                become a leading player in the sustainable beauty sector, delivering both scientific
                                and market impact.
                            </div>
                        </div>
                        <div id="Entrepreneurship-3-2" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Business Model Canvas
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/entrepreneurship/entrepreneurship-2.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <div className="mt-5">
                                BioGlimmer brings an innovative approach to guanine crystal production, redefining
                                how the cosmetics industry sources this key ingredient. By focusing on sustainability
                                and ethical practices, BioGlimmer positions itself as a leader in the growing sector
                                of sustainable beauty solutions.
                            </div>
                            <div className="mt-5 font-bold">
                                Key Partners
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s partnerships are central to its success, with its collaboration
                                strategy providing both technical expertise and market reach. Partnering with
                                research institutions is crucial for ongoing advancements in genetic modification
                                techniques, especially with complex R&D surrounding the A. caviae and E. coli
                                strains. This ensures BioGlimmer stays at the cutting edge of synthetic biology.
                            </div>
                            <div className="mt-5">
                                In cosmetics, multinational enterprises (MNEs) are very often oriented towards their
                                home region. However a world distribution of sales is usually developed as part of
                                their downstream activities (2). Thus it seems vital to communicate with big
                                cosmetics brands considering Sweden or the European region their home. Their
                                feedback will help shape BioGlimmer’s manufacturing plan into a profitable and
                                viable process.
                            </div>
                            <div className="mt-5">
                                Cosmetics manufacturers offer a direct pathway to market, allowing BioGlimmer to
                                integrate its solution into product formulations, while NGOs and sustainability
                                advocates provide credibility and boost its ethical standing. These partnerships
                                strengthen BioGlimmer's commitment to sustainability and promote industry-wide
                                adoption of ethical practices.
                            </div>
                            <div className="mt-5 font-bold">
                                Key Activities
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s R&D efforts in developing genetically modified strains form the
                                backbone of its product innovation. The company’s research into enhancing guanine
                                synthesis without compromising cell viability showcases its technical prowess.
                                Additionally, scaling up production of guanine crystals for commercial use
                                represents a critical step, ensuring that BioGlimmer can meet demand as the
                                market shifts towards sustainable and vegan alternatives. This combination of
                                research and production scalability will be essential for BioGlimmer’s future growth.
                            </div>
                            <div className="mt-5 font-bold">
                                Key Resources
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s primary resources include its proprietary modified bacterial strain,
                                which offers a competitive advantage in producing guanine crystals sustainably.
                                The intellectual property and technology behind these modified strains give
                                BioGlimmer a significant edge. Moreover, partnerships with cosmetic brands
                                provide essential market access, enabling the company to commercialize its product
                                through established channels and leverage existing brand reputations for consumer
                                trust.
                            </div>
                            <div className="mt-5 font-bold">
                                Value Proposition
                            </div>
                            <div className="mt-5">
                                The company’s value proposition lies in its focus on sustainable production and
                                ethical sourcing. BioGlimmer allows cosmetics brands to align their offerings with
                                the rapidly growing demand for cruelty-free, vegan, and environmentally responsible
                                products. By integrating BioGlimmer’s guanine crystals, brands can appeal to the
                                ethical and eco-conscious consumer, enhancing their own market position. In an
                                industry that increasingly values transparency and sustainability, BioGlimmer's
                                solution presents a clear path toward responsible beauty products.
                            </div>
                            <div className="mt-5 font-bold">
                                Customer Relationship
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s approach to customer relationships is based on building collaborative
                                partnerships with cosmetics manufacturers. By working closely with these brands,
                                BioGlimmer ensures that the technology and products align with the manufacturers'
                                sustainability goals. The company also emphasizes community outreach and educating
                                stakeholders on the benefits of sustainable guanine production, fostering stronger
                                ties with both the industry and consumers.
                            </div>
                            <div className="mt-5 font-bold">
                                Channels
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s primary sales channels include direct sales to cosmetics manufacturers,
                                where the company offers a B2B model for supplying guanine crystals. Additionally,
                                partnerships with cosmetic brands serve as an important channel for integrating
                                BioGlimmer’s solution into consumer products. Participation in symposiums and
                                industry events like ISSCR and sustainable beauty conferences provides further
                                visibility and credibility, helping to drive adoption within the cosmetics sector.
                            </div>
                            <div className="mt-5 font-bold">
                                Customer Segments
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s core customer segments include cosmetics brands and manufacturers
                                looking to incorporate sustainable, vegan ingredients into their product lines.
                                The company also targets ethical and vegan consumers indirectly by offering a
                                product that aligns with their values. By positioning itself within the ethical
                                beauty movement, BioGlimmer caters to the growing number of consumers demanding
                                transparency and sustainability in beauty products.
                            </div>
                            <div className="mt-5 font-bold">
                                Cost Structure
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s primary costs come from R&D, which requires significant investment
                                in genetic research, bacterial strain development, and product testing. Additionally,
                                operational costs related to scaling up guanine crystal production must be managed
                                efficiently. Lastly, regulatory compliance costs are critical, as navigating the
                                approval process for products derived from GMOs can be complex and costly. These
                                factors are crucial for maintaining the high quality and ethical standards
                                BioGlimmer promotes.
                            </div>
                            <div className="mt-5 font-bold">
                                Revenue Streams
                            </div>
                            <div className="mt-5">
                                BioGlimmer generates revenue through direct sales of its sustainably produced
                                guanine crystals to cosmetics manufacturers. The company also has the potential
                                to unlock new revenue by offering licensing opportunities for its proprietary
                                strain modifications, allowing other companies to produce guanine crystals using
                                BioGlimmer’s technology. These licensing deals could provide a steady and scalable
                                revenue stream as demand for sustainable ingredients grows.
                            </div>
                            <div className="mt-5 font-bold">
                                Conclusion
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s business model centers around innovation, sustainability, and ethical
                                production practices. By leveraging strategic partnerships with research
                                institutions, cosmetics manufacturers, and NGOs, and by focusing on solving key
                                environmental challenges, BioGlimmer is well-positioned to lead the shift toward
                                a more sustainable cosmetics industry. Its scalable production process and
                                commitment to aligning with consumer values offer a strong foundation for
                                long-term success in an increasingly competitive and conscientious market.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Entrepreneurship-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Milestones
                        </div>
                        <div id="Entrepreneurship-4-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Product Development & Research Milestones
                            </div>
                            <div className="mt-5">
                                The development of BioGlimmer’s vegan guanine crystal product is divided into
                                two critical phases, beginning with Phase 1: Genetic Engineering (0-6 months).
                                The key objective of this phase is to successfully genetically modify E. coli to
                                overexpress guanine crystals, as this will be the Minimum Viable Product (MVP).
                                This involves two key tasks:
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                First, transfecting with plasmids that express the guaA and guaB genes responsible
                                for guanine synthesis.
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Second, knocking out the guaD and xhd genes in E. coli to enhance guanine crystal output.
                            </div>
                            <div className="mt-5">
                                Laboratory trials are then conducted to measure guanine crystal production. The
                                milestone for this phase is to achieve consistent guanine crystal production in
                                lab-scale cultures. Challenges include potential genetic instability in modified
                                strains, which may require several iterations to resolve. Additionally, scaling
                                microbial production while maintaining consistency in guanine crystal quality
                                presents a significant hurdle.
                            </div>
                            <div className="mt-5">
                                Phase 2: Optimization & Scale-Up (6-12 months) focuses on transitioning from
                                lab-scale production to pilot-scale manufacturing. A crucial step here is the
                                development of a purification protocol that ensures the guanine crystals produced
                                meet cosmetic-grade standards. At the same time, BioGlimmer needs to engage with
                                manufacturers for process validation and scalability. Purchasing a 5-liter glass
                                microbial fermentation system under $20,000 is another key task. The objective is
                                to optimize both the yield and stability of guanine crystals within this larger
                                bioreactor system. Success will be defined by achieving pilot-scale production
                                that meets industry standards for purity and yield. The main challenges in this
                                phase include the high costs associated with scaling production and ensuring
                                consistency in the process as it is scaled up.
                            </div>
                        </div>
                        <div id="Entrepreneurship-4-2" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Market Analysis & Public Outreach
                            </div>
                            <div className="mt-5">
                                Once the product development has begun, BioGlimmer must also focus on understanding
                                the market and building public awareness of their solution. Phase 1: Market Research
                                (0-3 months) is all about identifying target segments within the cosmetic industry.
                                This involves conducting surveys and interviews with cosmetic brands to understand
                                the demand for guanine crystals, as well as the pain points related to the
                                traditional sources of this compound. Additionally, investigating competitors'
                                products from traditional guanine suppliers and synthetic alternatives is essential
                                to understanding the competitive landscape. The key milestone here is to develop a
                                customer profile and define the market size for sustainable, vegan guanine crystals.
                                The challenges lie in gathering reliable data for niche markets and navigating
                                potential intellectual property (IP) issues.
                            </div>
                            <div className="mt-5">
                                Phase 2: Public Outreach (3-9 months) focuses on creating awareness around the
                                ethical and environmental benefits of BioGlimmer’s solution. The company plans
                                to partner with key industry players and influencers in the vegan and sustainable
                                cosmetics space. They will launch campaigns that educate consumers on the ethical
                                issues related to traditional guanine crystal  sources, which often come from fish
                                scales. The milestone here is to build a community of early adopters and secure
                                letters of intent (LOIs) from major cosmetics brands, proving early market interest.
                                The major challenge will be convincing established industry players to switch from
                                their traditional guanine suppliers to BioGlimmer’s product.
                            </div>
                        </div>
                        <div id="Entrepreneurship-4-3" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Intellectual Property & Regulatory Strategy
                            </div>
                            <div className="mt-5">
                                Protecting the innovation behind BioGlimmer’s guanine crystal synthesis is crucial
                                for long-term success. Phase 1: IP & Patent Filings (0-9 months) involves securing
                                intellectual property rights for the unique biomanufacturing processes developed.
                                This phase includes filing for provisional patents on the genetically modified
                                E. coli strains and working with an IP lawyer to ensure freedom to operate. The
                                goal is to navigate the complex landscape of existing guanine-related patents and
                                avoid potential infringement issues. Achieving IP protection is the key milestone,
                                but overcoming potential IP challenges can be a significant obstacle.
                            </div>
                            <div className="mt-5">
                                Phase 2: Regulatory Approvals (9-16 months) is focused on ensuring the product
                                meets necessary regulatory standards for cosmetic ingredients. BioGlimmer must
                                work closely with regulatory bodies to meet safety and sustainability guidelines.
                                Toxicology assessments and safety validations will be critical to obtaining the
                                certifications needed for market entry. The milestone for this phase is to secure
                                all required regulatory certifications for launching the product in strategic
                                markets. Delays in obtaining these approvals could slow down time-to-market and
                                pose a significant challenge.
                            </div>
                        </div>
                        <div id="Entrepreneurship-4-4" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Commercialization & Go-To-Market Strategy
                            </div>
                            <div className="mt-5">
                                With the product ready and certified, BioGlimmer moves into Phase 1: Market Entry
                                (16-24 months). This phase focuses on launching the guanine crystals in the
                                cosmetic market. Finalizing the pricing strategy, based on production costs and
                                market research, is a critical task. BioGlimmer will also develop partnerships
                                with cosmetic manufacturers and distributors to launch pilot projects with
                                early-adopter brands. The key milestone is to get the first commercial product
                                on the market. However, the main challenge will be securing enough early customers
                                to validate the business model.
                            </div>
                            <div className="mt-5">
                                Phase 2: Expansion (24-40 months) is all about expanding into broader markets and
                                increasing production. BioGlimmer plans to develop a full product line catering to
                                different cosmetic industry needs, such as varying crystal colors for different
                                applications. Additionally, they will explore opportunities in adjacent industries
                                like self-care and sunscreen. Another key task is to begin discussions with
                                potential acquisition targets or strategic partners for long-term growth. The
                                milestone for this phase is to capture 5% market share in the guanine crystal
                                market. The challenges include facing competition from synthetic biology companies
                                and traditional incumbents adapting to vegan trends.
                            </div>
                        </div>
                        <div id="Entrepreneurship-4-5" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Financial Plan & Funding Milestones
                            </div>
                            <div className="mt-5">
                                BioGlimmer’s financial strategy is structured around two key funding rounds.
                                Phase 1: Seed Round (0-9 months) aims to raise $100,000 in seed funding from angel
                                investors and venture capital firms that specialize in synthetic biology and vegan
                                products. Another task is to apply for grants and accelerator programs focused on
                                sustainable innovation. The key milestone is to close the seed round and allocate
                                resources for genetic engineering and market research. A major challenge is
                                convincing investors of scalability and market readiness.
                            </div>
                            <div className="mt-5">
                                Phase 2: Series A (9-24 months) seeks to raise $1 million to scale production and
                                expand market presence. This involves preparing a detailed financial model showing
                                projected revenues, production costs, and market growth. The milestone is to achieve
                                positive cash flow within 24 months post-Series A. However, investor concerns about
                                long-term profitability and market risks will be key challenges.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/entrepreneurship/entrepreneurship-3.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                        </div>
                        <div id="Entrepreneurship-4-6" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Risk Management
                            </div>
                            <div className="mt-5">
                                BioGlimmer faces several risks, including:
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Technical risks such as challenges in scaling microbial production.
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Market risks, particularly competition from traditional guanine crystal suppliers and
                                synthetic alternatives.
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Regulatory risks, especially the potential for delays in obtaining safety
                                certifications that could slow down time-to-market.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Entrepreneurship-5" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Long term impact
                        </div>
                        <div id="Entrepreneurship-5-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Potential positive impact
                            </div>
                            <div className="mt-5">
                                The long-term impact of BioGlimmer's success will be transformative for both the
                                company and the cosmetics industry. As BioGlimmer continues to win market share,
                                it will establish a new standard for sustainable, cruelty-free ingredients, driving
                                a widespread shift away from animal-derived guanine and similar compounds. This
                                will lead to increased demand for ethical products across the industry, forcing
                                traditional suppliers to either adapt or face declining relevance. In the long
                                term, BioGlimmer's innovative approach will influence consumer expectations,
                                pushing the beauty market further toward sustainability and transparency.
                            </div>
                            <div className="mt-5">
                                Success will attract competitors, both from synthetic biology and alternative
                                ingredients, prompting BioGlimmer to expand rapidly, scale production, and solidify
                                its position as a leader in the market. As production scales, the company will need
                                to maintain consistent product quality, optimize its manufacturing processes, and
                                invest in partnerships with large cosmetic brands to meet growing demand.
                                BioGlimmer's success will strengthen its brand and position it as a market leader,
                                attracting investor interest and opening opportunities for adjacent markets like
                                skincare and personal care. The shift toward sustainable beauty will influence
                                consumer preferences as such products will be more advertised and available than
                                ever before. This shall push regulatory bodies to adopt stricter standards for
                                ethical ingredients. Overall, BioGlimmer's market win will redefine the landscape
                                of cosmetic ingredients, force supply chain transformations, and position the
                                company for long-term growth and industry leadership.
                            </div>
                        </div>
                        <div id="Entrepreneurship-5-2" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Potential negative impact
                            </div>
                            <div className="mt-5">
                                Long-term risks that may not directly affect BioGlimmer but could still impact
                                the broader ecosystem include environmental, social, and regulatory shifts. For
                                instance, as more companies move toward biomanufacturing and synthetic biology,
                                there could be unintended environmental consequences. Large-scale microbial
                                fermentation processes, while more sustainable than traditional methods, still
                                require significant energy, water, and resources. Over time, if not managed
                                sustainably, this could contribute to ecological strain or raise concerns about
                                industrial biotechnology's environmental footprint, leading to new regulations
                                that impact the entire industry. Socially, there is a potential for public backlash
                                against the increasing use of genetically modified organisms (GMOs) in consumer
                                products. Even with strong safety and ethical assurances, consumer perception of
                                GMOs can be unpredictable and depends on scientific literacy (5).
                                Furthermore, global trade policies and geopolitical
                                instability could affect the availability of critical raw materials or disrupt
                                the supply chains for the biotechnology industry. For example, a shift in trade
                                regulations around biotechnology or GMO-derived products could raise costs for
                                the entire sector, indirectly influencing BioGlimmer’s operations.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Entrepreneurship-6" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Surveys
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                BioGlimmer is actively seeking valuable feedback from stakeholders with expertise
                                in biomanufacturing, biotechnology, startup creation, and patent legislation.
                                After pitching to two startup incubation hubs and participating in the iGEM Startup
                                Summer School, the team has developed a foundational understanding of how to
                                engage with and approach stakeholders.
                            </div>
                            <div className="mt-5">
                                The next step is to apply these skills in meetings with stakeholders from the
                                cosmetic and biomanufacturing industries to assess the potential value of
                                BioGlimmer’s product. Surveys will be conducted during these meetings with
                                potential collaborators, customers, mentors, and even competitors, when relevant.
                                Additionally, they will be distributed more broadly to professionals with key
                                roles in guanine crystal manufacturing and the cosmetics market.
                            </div>
                        </div>
                        <div id="Entrepreneurship-6-1" className="mt-6">
                            <div className="w-full h-screen mt-5">
                                <object
                                    type="application/pdf"
                                    width="100%"
                                    height="100%"
                                    data="https://static.igem.wiki/teams/5122/pdf/survey-1.pdf"
                                >
                                    <p>Your web browser doesn't have a PDF plugin.</p>
                                </object>
                            </div>
                        </div>
                        <div id="Entrepreneurship-6-2" className="mt-6">
                            <div className="w-full h-screen mt-5">
                                <object
                                    type="application/pdf"
                                    width="100%"
                                    height="100%"
                                    data="https://static.igem.wiki/teams/5122/pdf/survey-2.pdf"
                                >
                                    <p>Your web browser doesn't have a PDF plugin.</p>
                                </object>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Entrepreneurship-7" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            References
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <ol className="list-decimal space-y-4 pl-5">
                                <li>
                                    Levy-Lior A, Pokroy B, Levavi-Sivan B, Leiserowitz L, Weiner S, Addadi L. Biogenic Guanine Crystals from the Skin of Fish May Be Designed to Enhance Light Reflectance. Cryst Growth Des. 2008 Feb 1;8(2):507–11.
                                </li>
                                <li>
                                    Oh CH, Rugman AM. Regional Sales of Multinationals in the World Cosmetics Industry. Eur Manag J. 2006 Apr;24(2–3):163–73.
                                </li>
                                <li>
                                    Business Research Insights. (2024, September 2). Guanine Market Size, Share, Trends Analysis Research, 2032. Business Research Insights. Retrieved September 29, 2024, from https://www.businessresearchinsights.com/market-reports/guanine-market-108358
                                </li>
                                <li>
                                    Chen X, Zhou L, Tian K, Kumar A, Singh S, Prior BA, et al. Metabolic engineering of Escherichia coli: A sustainable industrial platform for bio-based chemical production. Biotechnol Adv. 2013 Dec;31(8):1200–23.
                                </li>
                                <li>
                                    Wunderlich S, Gatto KA. Consumer Perception of Genetically Modified Organisms and Sources of Information. Adv Nutr. 2015 Nov;6(6):842–51.
                                </li>
                            </ol>
                        </div>
                    </div>


                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}